import { render, staticRenderFns } from "./StreamAddViewersCard.vue?vue&type=template&id=521e8c90&scoped=true&"
import script from "./StreamAddViewersCard.vue?vue&type=script&lang=js&"
export * from "./StreamAddViewersCard.vue?vue&type=script&lang=js&"
import style0 from "./StreamAddViewersCard.vue?vue&type=style&index=0&id=521e8c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e8c90",
  null
  
)

export default component.exports